export default function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/map.js
// module id = 189
// module chunks = 0